<template>
  <div>
    <el-row>
      <el-col>
        <h1>My PEAs</h1>
        <status-dropdown v-model="status" :inputModel="status"></status-dropdown>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
      <el-alert v-if="alertTitle !== ''"
        :title="alertTitle"
        :type="alertType"
        :description="callInfo"
        :closable="false"
        show-icon>
      </el-alert>
      </el-col>
    </el-row>
      <pea-table
        :tableData="tableData"
        :page="page"
        :pageSize="pageSize"
        :resultTotal="resultTotal"
        :status="status"
        :tableLoading="tableLoading"
        :selectRow="selectRow"
        :currentChange="getPeas"
      >
      </pea-table>
  </div>
</template>

<script>
import router from '@/router'
import {statusList} from '@/components/utility/statusList.js'
import helperMethods from '@/components/utility/helperMethods.js'
import { mapActions } from 'vuex'
export default {
  props: {
    statusId: 0
  },
  mixins: [statusList],
  data () {
    return {
      alertType: '',
      alertTitle: '',
      callInfo: '',
      tableData: null,
      page: 1,
      pageSize: 5,
      resultTotal: 0,
      status: parseInt(this.statusId),
      tableLoading: true
    }
  },
  computed: {
    filter: function () {
      if (this.status > 0) {
        return 'filter=status:' + this.status + '&'
      }
      return ''
    }
  },
  watch: {
    status: function () {
      router.push('/my-peas/status/' + this.status)
    }
  },
  methods: {
    ...mapActions(['user', 'getAccessToken', 'getDataToken']),
    getPeas: function () {
      this.getAccessToken(this.$msalInstance).then((response) => {
        this.tableLoading = true
        var call = '/myPEAs?' + this.filter + 'page=' + this.page + '&pageSize=' + this.pageSize
        this.$axios.get(call).then((response) => {
          this.tableData = response.data.results
          this.resultTotal = response.data.totalRecords
          this.tableLoading = false
        }).catch(reject => {
          this.tableLoading = false
          this.tableData = null
          this.resultTotal = 0
          helperMethods.showNotification(this, 'Error returning PEAs', reject.body, 'error', 30000, '')
        })
      })
    },
    selectRow: function (row) {
      router.push('/editPea/' + row.id)
    }
  },
  mounted: function () {
    this.getPeas()
  },
  created: function () {
    this.$on('page', function (value) {
      this.page = value
    })
    this.$on('pageSize', function (value) {
      this.pageSize = value
    })
    this.$on('resultTotal', function (value) {
      this.resultTotal = value
    })
  }
}
</script>

<style scoped>
    ul {
      padding: 0;
      margin: 0;
      margin-left: 10px;
    }

    .el-select {
      width: auto;
      position: relative;
      top: 3px;
    }

    h1 {
      float: left;
      margin-right: 30px;
    }
</style>

<style>
  .myPeasTable tr:hover {
    cursor: pointer;
  }
</style>
